/** Default typography for marketing emails (compose, preview, and delivery). */
export const MARKETING_EMAIL_FONT_FAMILY = 'Arial, Helvetica, sans-serif';
export const MARKETING_EMAIL_FONT_SIZE = '14px';
export const MARKETING_EMAIL_LINE_HEIGHT = '1.6';
export const MARKETING_EMAIL_TEXT_COLOR = '#1e293b';

export const MARKETING_EMAIL_INLINE_BODY_STYLE = [
  `font-family:${MARKETING_EMAIL_FONT_FAMILY}`,
  `font-size:${MARKETING_EMAIL_FONT_SIZE}`,
  `line-height:${MARKETING_EMAIL_LINE_HEIGHT}`,
  `color:${MARKETING_EMAIL_TEXT_COLOR}`,
  'font-weight:400',
].join(';');

export const DEFAULT_MARKETING_EMAIL_TEMPLATE_HTML =
  '<p>Hello,</p><p>Your message here.</p>';

export const DEFAULT_MARKETING_EMAIL_SIGNATURE_HTML =
  '<p style="margin:0;"><strong>Vedika Health Team</strong><br/>marketing@vedikahealth.com<br/>www.vedikahealth.com</p>';

/** Wrap HTML for email-client delivery and accurate preview. */
export function wrapMarketingEmailBody(html: string): string {
  const trimmed = (html || '').trim();
  if (!trimmed) return trimmed;
  if (/^<div style="font-family:\s*(?:Verdana|Arial)/i.test(trimmed)) return trimmed;
  return `<div style="${MARKETING_EMAIL_INLINE_BODY_STYLE}">${trimmed}</div>`;
}
